import { camelize, dasherize } from '@ember/string';

import { Transform } from '@warp-drive/legacy/serializer/transform';

export default class StoryContentTransform extends Transform {
  deserialize(serialized) {
    let attributes = ['showMore', 'headline', 'subType'];

    serialized.forEach((item) => {
      let type = Object.keys(item).find((key) => !attributes.includes(key));
      item.id = item[type];
      item.type = dasherize(type);
      delete item[type];
    });

    return serialized;
  }

  serialize(deserialized) {
    deserialized.forEach((item) => {
      let type = camelize(item.type);
      item[type] = item.id;
      delete item.id;
      delete item.type;
    });

    return deserialized;
  }
}
